<template>
  <div class="pa-3 white lighten-1">
    <v-layout row wrap>
      <v-flex xs4>
        <v-select
          :items="tagTypes"
          v-model="selectedTagType"
          :label="$t('rms.field.avails.form.label.type')"
          outline
          @change="onTagTypeChange"
        ></v-select>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-layout class="mt-5" row wrap justify-center align-center>
      <v-flex xs12>
        <v-layout row wrap justify-center align-center>
          <v-flex xs5>
            <v-layout class="translationBox" row wrap>
              <v-flex xs12>
                <v-card-title class="grey lighten-4 pa-3">
                  <h3 class="secondary--text">
                    {{ getLanguageFromCode("en") }}
                  </h3>
                  <v-spacer></v-spacer>
                  <v-alert :value="showTranslationDeletedMessage" color="success" icon="check_circle" outline class="pa-1 pr-2"> 
                    {{ $t('company.tag.deleted.success.message') }}
                  </v-alert>
                </v-card-title>
              </v-flex>
              <v-flex xs12 v-for="(tag, index) in languageTags" :key="tag.id" class="pb-1 px-2">
                <v-text-field
                    :value="tag.name[defaultLanguage]"
                    :prefix="`${index + 1}.`"
                    dense
                    append-outer-icon="mdi-delete"
                    @click:append-outer="deleteTag(tag)"
                    hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs2>
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs5>
            <v-layout class="translationBox" row wrap>
              <v-flex xs12>
                <v-card-title class="grey lighten-4 pa-2">
                  <v-menu offset-y class="pa-0">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        text
                        flat
                        v-on="on"
                        small
                        class="mx-0 px-0 primary--text"
                      >
                        {{ getLanguageFromCode(translateToLanguage) }}
                        <v-icon small>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <div
                        v-for="(item, index) in DEFINES.LOCALES"
                        :key="index"
                      >
                        <v-list-tile @click="changeTranslateToLanguage(item)">
                          <v-list-tile-title
                            :class="[
                              item.value == translateToLanguage
                                ? 'primary--text'
                                : '',
                            ]"
                            >{{ item.text }}</v-list-tile-title
                          >
                        </v-list-tile>
                        <v-divider></v-divider>
                      </div>
                    </v-list>
                  </v-menu>
                  <v-spacer></v-spacer>
                  <v-alert :value="showTranslationUpdatedMessage" color="success" icon="check_circle" outline class="pa-1 pr-2">    {{ $t('company.tag.translation.updated.success.message') }} 
                  </v-alert>
                </v-card-title>
              </v-flex>
              <v-flex xs12 v-for="(tag, index) in languageTags" :key="tag.id" class="pb-1 px-2">
                <v-text-field
                    v-model="tag.name[translateToLanguage]"
                    :prefix="`${index + 1}.`"
                    dense
                    hide-details
                    append-outer-icon="mdi-upload"
                    @click:append-outer="translateTag(tag)"
                >
            </v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapState } from "vuex";
import DEFINES from "@/defines";
export default {
  name: "TranslateTags",
  data() {
    return {
      defaultLanguage: "en",
      selectedTagType: null,
      languageTags: [],
      translateToLanguage: "en",
      showTranslationUpdatedMessage: false,
      showTranslationDeletedMessage: false
    };
  },
  filters: {
    capitalize:(value) => value.toUpperCase() + value.slice(1)
  },
  computed: {
    ...mapState({
      company: (state) => state.company.company,
    }),
    tagTypes() {
      if (this.company && this.company.id === DEFINES.NETFEST_VOD_COMPANY_ID) {
        return DEFINES.TAG_TYPES;
      }else{
        return DEFINES.TAG_TYPES.filter((tagType) => {
          return tagType.value !== "vod_random";
        });
      }
    },
  },
  watch: {
    selectedTagType: {
      handler(newValue, oldValue) {
        this.getTags(newValue, this.defaultLanguage);
      },
    },
  },
  methods: {
    async getTags(tagType, language = "en") {
      try {
        return await this.$store.dispatch("tag/listWithLanguage", {
          tag_type: tagType,
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },

    async onTagTypeChange(tagType) {
      this.languageTags = await this.getTags(tagType, this.defaultLanguage);
    },

    getLanguageFromCode(code) {
      return DEFINES.LOCALES.find((language) => language.value == code).text;
    },

    changeTranslateToLanguage(language) {
        this.translateToLanguage = language.value
    },

    async translateTag(tag){
        await this.$store.dispatch('tag/updateTranslation', {
            id: tag.id,
            language: this.translateToLanguage,
            value: tag.name[this.translateToLanguage]
        })
        .then((res)=> {
            this.showTranslationUpdated()
        })
        .catch((error) => {
            this.$store.dispatch("app/showMessage", {
                message: error.message,
                color: "error",
            });
        })
    },
    async deleteTag(tag) {
      try {
          await this.$store.dispatch("tag/deleteTag", {id:tag.id})
          .then(() => {
              this.showTranslationDeleted();
          });
          this.languageTags = this.languageTags.filter((t) => t.id !== tag.id);
      } catch (error) {
          this.$store.dispatch("app/showMessage", {
              message: error.message,
              color: "error",
          });
      }
    },
    showTranslationUpdated() {
        this.showTranslationUpdatedMessage = true;
        setTimeout(() => {
            this.showTranslationUpdatedMessage = false
        }, 1000);
    },
    showTranslationDeleted() {
        this.showTranslationDeletedMessage = true;
        setTimeout(() => {
            this.showTranslationDeletedMessage = false
        }, 1000);
    }
  },
};
</script>
  <style scoped>
span {
  content: "\27F6";
}
.divider {
  width: 1px;
  background-color: black; /* Color of the divider */
  height: 100vh; /* Full height */
}
.translationBox {
    border: 2px solid rgba(0,0,0,.12);
}
</style>
